// eslint-disable-next-line import/no-cycle
import { post, get, del } from 'utils/methods';

export function startPaletteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job-palette/state`, data, headers);
}

export function getJobPalettesToStartApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}job-palettes`, data, headers);
}

export function getCoatingInApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}machine-job-palettes`, data, headers);
}

export function deleteJobResultApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}
